import React from 'react'
import HeaderContent from './header-content'
// import HeaderSearch from './header-search'
import ProfileInfo from './profile-info'
// import Notifications from './notifications'
// import Messages from "./messages"
import ThemeSwitcher from './theme-switcher'
// import HorizontalMenu from "./horizontal-menu"
import HeaderLogo from "./header-logo"
// import SidebarHoverToggle from '../sidebar/sidebar-hover-toggle'
import { useConfig } from 'hooks/use-config'
import { Menu } from "lucide-react"
import { Button } from "components/ui/button";


const StorboltHeader = () => {
    const [config, setConfig] = useConfig();

    return (
        <>
            <HeaderContent>
                <div className='flex gap-3 items-center'>
                    <HeaderLogo/>
                    {/*<HeaderSearch />*/}
                </div>
                <div className="nav-tools flex items-center  md:gap-4 gap-3">
                    <ThemeSwitcher/>
                    <Button size="icon" rounded="full"
                            className="lg:hidden px-2 md:bg-secondary bg-transparent hover:ring-0  md:h-8 md:w-8 h-auto w-auto text-default-900 hover:bg-secondary hover:ring-offset-0"
                            onClick={() => setConfig({
                                ...config,
                                menuHidden: !config.menuHidden,
                                collapsed: false
                            })}>
                        <Menu className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100"/>
                        <span className="sr-only">Toggle menu</span>
                    </Button>
                    {/*<Messages />*/}
                    {/*<Notifications />*/}
                    <ProfileInfo/>
                </div>
            </HeaderContent>
            {/* <HorizontalMenu /> */}
        </>
    )
}

export default StorboltHeader